import { Checkbox as CheckboxComponent } from "../ui/checkbox";
import { cn } from "~/lib/utils";

type CheckboxProps = React.ComponentProps<typeof CheckboxComponent>;

export function Checkbox({ className, ...props }: CheckboxProps) {
  return (
    <CheckboxComponent
      className={cn(
        // "bg-white p-0 shadow-none italic w-32 data-[state=checked]:bg-white data-[state=checked]:border-none text-sm",
        "cursor-pointer bg-white size-5 border border-gray-300",
        "data-[state=checked]:bg-secondary-700 data-[state=checked]:border-none",
        className
      )}
      {...props}
    />
  );
}
